const HEADER_SELECTOR = '.header-content.fixed';
const WRAPPER_SELECTOR = '#wrapper';
const SCROLL_CLASS = 'is-scrolling';
const SCROLL_THRESHOLD = 50;

const debounce = (fn, delay = 150) => {
  let debounceTimer = null;
  return (...args) => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

const rafThrottle = (fn) => {
  let pending = false;
  let lastArgs;

  const run = () => {
    pending = false;
    fn(...(lastArgs || []));
    lastArgs = undefined;
  };

  return (...args) => {
    lastArgs = args;
    if (!pending) {
      pending = true;
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(run);
      } else {
        setTimeout(run, 16);
      }
    }
  };
};

const updateHeaderPadding = (header, wrapper) => {
  if (!header || !wrapper) {
    return;
  }

  const height = header.offsetHeight;
  wrapper.style.paddingTop = height ? `${height}px` : '';
};

const updateScrollState = (header) => {
  if (!header) {
    return;
  }

  if (window.scrollY > SCROLL_THRESHOLD) {
    header.classList.add(SCROLL_CLASS);
  } else {
    header.classList.remove(SCROLL_CLASS);
  }
};

const setupHeaderLayout = () => {
  const header = document.querySelector(HEADER_SELECTOR);
  const wrapper = document.querySelector(WRAPPER_SELECTOR);

  if (!header || !wrapper) {
    return;
  }

  const throttledPaddingUpdate = rafThrottle(() => updateHeaderPadding(header, wrapper));
  const throttledScrollUpdate = rafThrottle(() => updateScrollState(header));

  throttledPaddingUpdate();
  throttledScrollUpdate();

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(throttledPaddingUpdate);
    resizeObserver.observe(header);
  } else {
    const debouncedResize = debounce(throttledPaddingUpdate, 200);
    window.addEventListener('resize', debouncedResize, { passive: true });
  }

  window.addEventListener('scroll', throttledScrollUpdate, { passive: true });
};

export function initHeaderLayout() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeaderLayout, { once: true });
  } else {
    setupHeaderLayout();
  }
}
